/* Don Cotillón · Halloween v7 — interacciones que venden */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const clp = (n) => '$' + Math.round(Number(n) || 0).toLocaleString('es-CL');
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- Cuentas regresivas ---------- */
  const pad = (n) => String(Math.max(0, n)).padStart(2, '0');
  const nextMidnight = () => { const d = new Date(); d.setHours(24, 0, 0, 0); return d.getTime(); };
  const timers = $$('[data-hw-countdown]').map((el) => ({
    el, end: el.dataset.end === 'midnight' ? nextMidnight() : new Date(el.dataset.end).getTime()
  }));
  const tick = () => {
    const now = Date.now();
    timers.forEach((t) => {
      if (t.el.dataset.end === 'midnight' && t.end - now <= 0) t.end = nextMidnight();
      let left = t.end - now;
      if (!Number.isFinite(t.end) || left <= 0) {
        const clock = $('[data-clock]', t.el);
        if (clock && t.el.dataset.done) clock.textContent = t.el.dataset.done;
        return;
      }
      const s = Math.floor(left / 1000);
      const set = (k, v) => { const n = $(`[data-${k}]`, t.el); if (n) n.textContent = pad(v); };
      const d = Math.floor(s / 86400);
      set('d', d);
      set('h', $('[data-d]', t.el) ? Math.floor((s % 86400) / 3600) : Math.floor(s / 3600));
      set('m', Math.floor((s % 3600) / 60));
      set('s', s % 60);
    });
  };
  if (timers.length) { tick(); setInterval(tick, 1000); }

  $$('[data-hw-days]').forEach((el) => {
    const days = Math.ceil((new Date(el.dataset.end).getTime() - Date.now()) / 86400000);
    if (days > 1) el.textContent = `quedan ${days} días`;
    else if (days === 1) el.textContent = '¡es mañana!';
    else if (days === 0) el.textContent = '¡es hoy!';
  });

  /* ---------- Mensajes rotativos de la barra ---------- */
  $$('[data-hw-rotate]').forEach((box) => {
    const items = $$('.hw-bar__msg', box);
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => { items[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on'); }, 4200);
  });

  /* ---------- Pestañas ---------- */
  $$('[data-hw-tabs]').forEach((wrap) => {
    const tabs = $$('[role="tab"]', wrap);
    const select = (tab) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1;
        const p = document.getElementById(t.getAttribute('aria-controls')); if (p) p.hidden = !on;
      });
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        n.focus(); select(n);
      });
    });
  });

  /* ---------- Carro: agregar con un toque ---------- */
  const toast = $('[data-hw-toast]');
  let toastTimer;
  const showToast = (label, img) => {
    if (!toast) return;
    $('[data-hw-toast-label]', toast).textContent = label || '';
    const im = $('[data-hw-toast-img]', toast);
    if (img) { im.src = img; im.hidden = false; } else im.hidden = true;
    toast.hidden = false; requestAnimationFrame(() => toast.classList.add('is-on'));
    clearTimeout(toastTimer); toastTimer = setTimeout(hideToast, 5000);
  };
  const hideToast = () => { if (!toast) return; toast.classList.remove('is-on'); setTimeout(() => { toast.hidden = true; }, 250); };
  toast && $('[data-hw-toast-close]', toast).addEventListener('click', hideToast);

  const refreshCart = (sections) => {
    if (sections && sections['cart-icon-bubble']) {
      const bubble = document.getElementById('cart-icon-bubble');
      const html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (bubble && html) bubble.innerHTML = html.innerHTML;
    }
    fetch(root + 'cart.js').then((r) => r.json()).then((c) => {
      $$('[data-hw-cart-count]').forEach((b) => { b.textContent = c.item_count; b.hidden = c.item_count === 0; });
    }).catch(() => {});
  };

  const addItems = async (items) => {
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: 'cart-icon-bubble' })
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'No se pudo agregar');
    refreshCart(data.sections);
    document.dispatchEvent(new CustomEvent('hw:cart-added', { detail: data }));
    return data;
  };

  const cardInfo = (btn) => {
    const card = btn.closest('[data-hw-card]');
    return { img: card && card.dataset.img, title: card && card.dataset.title };
  };

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-hw-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-busy')) return;
    const old = btn.innerHTML;
    btn.classList.add('is-busy'); btn.innerHTML = '⏳';
    try {
      await addItems([{ id: Number(btn.getAttribute('data-hw-add')), quantity: 1 }]);
      btn.classList.add('is-done'); btn.innerHTML = '✓ ' + (btn.classList.contains('hw-pill') ? old : 'Agregado');
      const info = cardInfo(btn);
      showToast(btn.dataset.label || info.title, info.img);
      setTimeout(() => { btn.classList.remove('is-done'); btn.innerHTML = old; }, 2200);
    } catch (err) {
      btn.innerHTML = 'Sin stock suficiente';
      setTimeout(() => { btn.innerHTML = old; }, 2200);
    } finally { btn.classList.remove('is-busy'); }
  });

  /* ---------- Arma tu look (bandeja) ---------- */
  $$('[data-hw-look]').forEach((look) => {
    const tray = $('[data-hw-tray]', look);
    const kit = new Map();
    const render = () => {
      let total = 0;
      const thumbs = $('[data-hw-tray-thumbs]', tray); thumbs.innerHTML = '';
      kit.forEach((it) => {
        total += it.price;
        const s = document.createElement('span'); s.className = 'hw-tray__thumb';
        if (it.img) { const i = new Image(); i.src = it.img; i.alt = ''; s.appendChild(i); } else s.textContent = '🎃';
        thumbs.appendChild(s);
      });
      $('[data-hw-tray-count]', tray).textContent = kit.size;
      $('[data-hw-tray-total]', tray).textContent = clp(total / 100);
      tray.hidden = kit.size === 0;
      look.classList.toggle('has-tray', kit.size > 0);
    };
    look.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-hw-kit-add]');
      if (!btn) return;
      const id = btn.getAttribute('data-hw-kit-add');
      const card = btn.closest('[data-hw-card]');
      // una opción por producto: al elegir otra talla/color se reemplaza
      $$('[data-hw-kit-add]', card).forEach((b) => { if (b !== btn) { kit.delete(b.getAttribute('data-hw-kit-add')); b.classList.remove('is-picked'); } });
      if (kit.has(id)) { kit.delete(id); btn.classList.remove('is-picked'); }
      else { kit.set(id, { price: Number(btn.dataset.price) || 0, img: card && card.dataset.img }); btn.classList.add('is-picked'); }
      render();
    });
    $('[data-hw-tray-clear]', tray).addEventListener('click', () => { kit.clear(); $$('.is-picked', look).forEach((b) => b.classList.remove('is-picked')); render(); });
    $('[data-hw-tray-buy]', tray).addEventListener('click', async (e) => {
      const b = e.currentTarget; const old = b.textContent; b.textContent = 'Agregando…';
      try {
        await addItems(Array.from(kit.keys()).map((id) => ({ id: Number(id), quantity: 1 })));
        showToast(`Tu look (${kit.size} productos) ya está en el carro`, null);
        kit.clear(); $$('.is-picked', look).forEach((x) => x.classList.remove('is-picked')); render();
      } catch (err) { b.textContent = 'Algo se agotó, revisa tu look'; setTimeout(() => { b.textContent = old; }, 2500); return; }
      b.textContent = old;
    });
  });

  /* ---------- Buscador de disfraz ---------- */
  $$('[data-hw-finder]').forEach((f) => {
    const state = {};
    const steps = $$('[data-step]', f);
    const go = (n) => {
      steps.forEach((s) => { s.hidden = s.dataset.step !== String(n); s.classList.toggle('is-on', s.dataset.step === String(n)); });
      $$('[data-step-dot]', f).forEach((d) => d.classList.toggle('is-on', Number(d.dataset.stepDot) <= Math.min(n, 3)));
      state.step = n;
    };
    const norm = (s) => (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const priceOf = (v) => Number(v.price) || 0;
    const cardHTML = (p) => {
      const avail = p.variants.filter((v) => v.available);
      const v0 = avail[0] || p.variants[0];
      const price = priceOf(v0); const cmp = v0.compare_at_price ? priceOf({ price: v0.compare_at_price }) : 0;
      const pct = cmp > price ? Math.round((cmp - price) * 100 / cmp) : 0;
      const img = p.images && p.images[0] ? p.images[0].src + (p.images[0].src.includes('?') ? '&' : '?') + 'width=400' : '';
      const url = root + 'products/' + p.handle;
      const single = p.variants.length === 1 && /default/i.test(p.variants[0].title);
      let actions;
      if (single) actions = `<button type="button" class="hw-btn hw-btn--add" data-hw-add="${v0.id}" data-label="${esc(p.title)}">Agregar al carro</button>`;
      else if (avail.length <= 10) actions = `<p class="hw-card__hint">Toca tu opción y se agrega:</p><div class="hw-card__pills">${avail.map((v) => `<button type="button" class="hw-pill" data-hw-add="${v.id}" data-label="${esc(p.title + ' · ' + v.title)}">${esc(v.title)}</button>`).join('')}</div>`;
      else actions = `<a class="hw-btn hw-btn--ghost" href="${url}">Elegir opción</a>`;
      return `<article class="hw-card" data-hw-card data-title="${esc(p.title)}" data-img="${esc(img)}">
        <a class="hw-card__media" href="${url}" tabindex="-1" aria-hidden="true">${img ? `<img class="hw-card__img" src="${esc(img)}" alt="" loading="lazy" width="400" height="400">` : '<span class="hw-card__noimg">🎃</span>'}
        <span class="hw-card__badges">${pct >= 5 ? `<span class="hw-badge hw-badge--off">-${pct}%</span>` : ''}</span></a>
        <div class="hw-card__body"><a class="hw-card__title" href="${url}">${esc(p.title)}</a>
        <div class="hw-card__price"><strong>${clp(price)}</strong>${pct >= 5 ? `<s>${clp(cmp)}</s>` : ''}</div>${actions}</div></article>`;
    };
    const run = async () => {
      go(4);
      const out = $('[data-hw-results]', f); const loading = $('[data-hw-loading]', f);
      out.innerHTML = ''; loading.hidden = false;
      $('[data-hw-more]', f).href = root + 'collections/' + state.who;
      try {
        const r = await fetch(`${root}collections/${state.who}/products.json?limit=250`);
        const { products = [] } = await r.json();
        const [min, max] = state.budget.split('-').map(Number);
        const inBudget = products.filter((p) => p.variants.some((v) => v.available) && (() => {
          const v = p.variants.find((x) => x.available); const pr = priceOf(v); return pr >= min && pr <= max;
        })());
        const keys = (state.style || '').split(',').map((k) => norm(k.trim())).filter(Boolean);
        const match = keys.length ? inBudget.filter((p) => { const t = norm(p.title + ' ' + (p.tags || []).join(' ')); return keys.some((k) => t.includes(k)); }) : inBudget;
        let list = match.slice(0, 12); let note = '';
        if (list.length < 4) { note = f.dataset.empty; const extra = inBudget.filter((p) => !list.includes(p)); list = list.concat(extra).slice(0, 12); }
        loading.hidden = true;
        $('[data-hw-result-title]', f).textContent = list.length ? `🎉 ${match.length ? match.length : 'Varios'} disfraces para ti` : 'Uy, no quedan en ese presupuesto';
        out.innerHTML = (note ? `<p class="hw-finder__note">${esc(note)}</p>` : '') + list.map(cardHTML).join('');
        if (!list.length) out.innerHTML = `<p class="hw-finder__note">Prueba otro presupuesto o escríbenos por WhatsApp y te ayudamos a encontrarlo.</p>`;
      } catch (err) {
        loading.hidden = true;
        out.innerHTML = `<p class="hw-finder__note">No pudimos cargar los disfraces. <a href="${root}collections/${state.who}">Ver colección →</a></p>`;
      }
      f.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    f.addEventListener('click', (e) => {
      const pick = e.target.closest('[data-hw-pick]');
      if (pick) {
        state[pick.dataset.hwPick] = pick.dataset.value;
        if (pick.dataset.hwPick === 'who') go(2);
        else if (pick.dataset.hwPick === 'style') go(3);
        else run();
        return;
      }
      if (e.target.closest('[data-hw-back]')) go(Math.max(1, state.step - 1));
      if (e.target.closest('[data-hw-restart]')) go(1);
    });
  });
})();
